<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-snackbar v-model="showsnackbar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
        <v-form ref="form" lazy-validation>
          <v-layout wrap>
            <v-flex xs12 pt-2>
              <v-card class="mb-1">
                <v-card-title>
                  Products
                  <!-- <v-spacer></v-spacer> -->
                </v-card-title>
                  <v-row class="ma-2">
                  <v-col cols="12" sm="3">
                    <v-text-field
                      v-model="searchKeyword"
                      append-icon="mdi-magnify"
                      solo
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-select
                      v-model="seller"
                      :items="sellerArray"
                      item-text="name"
                      item-value="value"
                      item-color="#8d8d8d"
                      color="#8d8d8d"
                      outlined
                      dense
                      label="Sellers"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-select
                      v-model="category"
                      :items="categoryArray"
                      item-text="name"
                      item-value="_id"
                      item-color="#8d8d8d"
                      color="#8d8d8d"
                      outlined
                      dense
                      label="Category"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-select
                      v-model="subCategory"
                      :items="subCategoryArray"
                      item-text="name"
                      item-value="_id"
                      item-color="#8d8d8d"
                      color="#8d8d8d"
                      outlined
                      dense
                      label="SubCategory"
                    >
                    </v-select>
                  </v-col>
                  </v-row>
              </v-card>
              <v-card class="mb-4">
                <v-card-text>
                  <v-layout wrap style="align-items: center" justify-center>
                    <v-flex xs6 sm6 md6></v-flex>
                    <v-flex xs6 sm6 md6>
                      <v-layout wrap justify-center>
                        <v-flex xs6 sm6 md4 text-right pt-2
                          >Items Per Page</v-flex
                        >
                        <v-flex xs6 sm6 md2>
                          <v-select
                            solo
                            flat
                            v-model="itemsPerPage"
                            :items="ItemsCount"
                            dense
                            required
                          ></v-select>
                        </v-flex>
                        <v-flex
                          xs6
                          sm6
                          md2
                          text-center
                          pt-2
                          style="color: black"
                        >
                          {{ pageStart }}-{{ pageEnd }} of {{ count }}
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-right>
                          <span v-if="page > 1">
                            <v-icon @click="prevpage" color="primary"
                              >mdi-chevron-left</v-icon
                            >
                          </span>
                          <span v-else>
                            <v-icon disabled color="primary"
                              >mdi-chevron-left</v-icon
                            >
                          </span>
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-center>
                          <!-- <v-text-field
                              v-model="page"
                              color="#26af82"
                              min="1"
                              :dense="true"
                              :max="totalpages"
                              type="number"
                              class="centered-input"
                            ></v-text-field> -->
                          {{ page }}
                        </v-flex>
                        <v-flex xs2 sm2 md1 pt-2 text-left>
                          <span v-if="page < totalpages">
                            <v-icon @click="nextpage" color="primary"
                              >mdi-chevron-right</v-icon
                            >
                          </span>
                          <span v-else>
                            <v-icon disabled color="primary"
                              >mdi-chevron-right</v-icon
                            >
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-layout wrap>
                  <v-flex v-for="(item, i) in products" :key="i" md3 pa-4>
                    <v-card
                      tile
                      flat
                      style="cursor: pointer"
                      @click="info(item)"
                    >
                      <v-img
                        v-if="item.photos.length > 0"
                        :src="baseURL + '/file/get/' + item.photos[0]"
                        height="200px"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="#0066ff"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-img
                        v-else
                        src="../../assets/user-info.jpg"
                        height="200px"
                      >
                      </v-img>
                      <v-layout wrap justify-center px-2>
                        <v-flex pt-2 xl12 text-left style="line-height: 16px">
                          <span style="font-size: 13px; color: #000000">
                            {{ item.name }}
                          </span>
                          <br />
                          <span
                            v-if="item.discount > 0"
                            style="font-size: 13px; color: #000000"
                          >
                            Rs.
                            {{
                              filterValue(
                                item.price * (1 - item.discount / 100)
                              )
                            }}
                          </span>
                          <span v-else style="font-size: 13px; color: #000000">
                            Rs. {{ filterValue(item.price) }}
                          </span>
                          <span
                            class="pl-2 text-decoration-line-through"
                            style="font-size: 13px"
                            v-if="item.discount > 0"
                          >
                            <strike> Rs. {{ filterValue(item.price) }} </strike>
                          </span>
                          <span
                            class="pl-2 text-decoration-line-through"
                            style="font-size: 13px; color: #3bc17a"
                            v-if="item.discount > 0"
                          >
                            {{ item.discount }}% Off
                          </span>
                          <br />
                          <span>
                            <v-rating
                              :value="parseInt(item.rating)"
                              color="#FFD341"
                              background-color="#e0e0e0"
                              empty-icon="$ratingFull"
                              half-increments
                              readonly
                              hover
                              small
                            ></v-rating>
                          </span>
                          <br />
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
// import pdf from 'vue-pdf'
export default {
  // components: {
  //   pdf
  // },
  data() {
    return {
      headers: [
        { text: "Customer", value: "firstname" },
        { text: "Products", value: "productname", tdClass: "tdwidth" },
        { text: "Amount", value: "amount" },
        { text: "Order Date", value: "Orderdate" },
        // { text: "Actions", value: "actions", sortable: false },
      ],
      showsnackbar: false,
      msg: null,
      timeout: 5000,
      deleteCustomer: false,
      mini: true,
      products: [],
      seller: "",
      sellerArray: [],
      searchKeyword: "",
      category: "",
      status: "active",
      categoryArray: [],
      subCategory: "",
      subCategoryArray: [],
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      itemsPerPage: 25,
      page: 1,
      totalpages: 0,
      ItemsCount: [25, 50, 100],
    };
  },
  beforeMount() {
    this.getProducts();
    this.getCategory();
    this.getSeller();
  },
  watch: {
    itemsPerPage: function () {
      this.getProducts();
    },
    category() {
      this.getSubCategory();
      this.getProducts();
    },
    subCategory() {
      this.getProducts();
    },
    seller() {
      this.getProducts();
    },
    searchKeyword() {
      this.getProducts();
    },
  },
  methods: {
    filterValue(value) {
      var val = value.toFixed(2);
      return Number(val).toLocaleString();
    },
    prevpage() {
      if (this.page > 1) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page--;
        this.getProducts();
        // } else {
        //   this.page--;
        //   this.getProducts();
        // }
      }
    },
    nextpage() {
      if (this.page < this.totalpages) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page++;
        this.getProducts();
        // } else {
        //   this.page++;
        //   this.getProducts();
        // }
      }
    },
    getProducts() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/product/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          limit: this.itemsPerPage,
          page: this.page,
          productStatus: "approved",
          categoryId: this.category,
          subcategoryId: this.subCategory,
          searchKeyword: this.searchKeyword,
          userid: this.seller,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.products = response.data.data;
          this.count = response.data.totalLength;
          this.totalpages = Math.ceil(
            response.data.totalLength / this.itemsPerPage
          );

          if (response.data.length > 0) {
            this.pageStart = (response.data.page - 1) * response.data.limit + 1;
            this.pageEnd = this.pageStart + response.data.length - 1;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    getSeller() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/sellers/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.temp = response.data.data;
           var temp = [
            {
              name: null,
              value: null,
            },
          ];
          temp = response.data.data;
          for (var i = 0; i < temp.length; i++) {
            temp[i].name = temp[i].sellerid.shopName;
            temp[i].value = temp[i]._id;
          }
          this.sellerArray = temp;
          this.sellerArray.unshift({ name: "All", value: null });
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    getCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/category/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.categoryArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    getSubCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/subcategory/list/" + this.category,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.subCategoryArray = response.data.data;
        })
        .catch((err) => {
          this.ServerError = true;
          this.appLoading = false;
          console.log(err);
        });
    },
    info(item) {
      this.$router.push("/productDetails/" + item._id);
    },
  },
};
</script>
<style >
tbody tr:nth-of-type(odd) {
  background-color: rgba(28, 133, 219, 0.05);
}
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
</style>